import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './@core/services/auth.guard';
import { SubscriptionAuthGuard } from './@core/services/subscription.guard';
export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],

    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: './auth.module#NgxAuthModule',
  },
  {
    path: 'subscribe', 
    canActivate: [SubscriptionAuthGuard], 
    loadChildren: () => import('./subscribe/subscribe-routing.module')
      .then(m => m.SubscribeRoutingModule)
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  // providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  exports: [RouterModule],
})

export class AppRoutingModule { }
